import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { PaymentSipEmandateComponent } from './payment-sip-emandate.component';
import { PaymentSipCardModule } from '../payment-sip-card/payment-sip-card.module';
import { PaymentSipNetBankingModule } from '../payment-sip-net-banking/payment-sip-net-banking.module';

@NgModule({
  declarations: [PaymentSipEmandateComponent],
  exports: [PaymentSipEmandateComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    PaymentSipCardModule,
    PaymentSipNetBankingModule
  ]
})
export class PaymentSipEmandateModule { }
